/**
 * Created by stonewang on 2017/8/14.
 */
import React from 'react';
import {
    Router,
    Route,
    IndexRoute,
    hashHistory,
} from 'react-router';
import App from './App';
import Home from './routes/home/index';
import Login from './routes/home/login';
/* 渠道 */
import Channel from './routes/channel';
import ChannelList from './routes/channel/list.js';
import ChannelAdd from './routes/channel/add.js';
import ChannelDetail from './routes/channel/detail.js';
/* 渠道 end */
/* 打印 */
// import Print from './routes/print';
/* 打印end */
/* 附件、备注 */
import FileList from './routes/remark/file.js';
import RemarkList from './routes/remark/remark.js';
/* 附件、备注 end */
/* 门店 */
import Store from './routes/store';
import StoreList from './routes/store/list.js';
import StoreAdd from './routes/store/add.js';
import StoreDetail from './routes/store/detail.js';
/* 门店 end */
/* 员工 */
import Staff from './routes/staff';
import StaffList from './routes/staff/list.js';
import StaffAdd from './routes/staff/add.js';
import StaffDetail from './routes/staff/detail.js';
/* 员工 end */
/* 联系人 */
import Linkman from './routes/linkman';
import LinkmanList from './routes/linkman/list.js';
import LinkmanAdd from './routes/linkman/add.js';
import LinkmanDetail from './routes/linkman/detail.js';
/* 联系人 end */
/* 卡券管理 */
import Card from './routes/card';
import CardList from './routes/card/list.js';
import CardAdd from './routes/card/add.js';
/* 卡券管理 end */
import Category from './routes/category';
import CategoryList from './routes/category/list.js';
import Categoryadd from './routes/category/add.js';
import Dictionary from './routes/dictionary';
import DictionaryList from './routes/dictionary/list.js';
import DictionaryAdditem from './routes/dictionary/additem.js';
import DictionaryDetail from './routes/dictionary/detail.js';
import DictionaryAdd from './routes/dictionary/add.js';
/* 促销管理 */
import Promotion from './routes/promotion';
import PromotionList from './routes/promotion/list.js';
import PromotionAdd from './routes/promotion/add.js';
import PromotionDetail from './routes/promotion/detail.js';
import ProductBrand from './routes/productBrand';
import ProBrandList from './routes/productBrand/list.js';
import ProBrandAdd from './routes/productBrand/add.js';
import ProductSpec from './routes/productSpec';
import ProductSpecList from './routes/productSpec/list.js';
import ProductSpecadd from './routes/productSpec/add.js';
import Region from './routes/region';
import RegionList from './routes/region/list.js';
import Regionadd from './routes/region/add.js';
import Role from './routes/role';
import RoleList from './routes/role/list.js';
import Roleadd from './routes/role/add.js';
import GlobalVar from './routes/globalVar';
import GlobalVarList from './routes/globalVar/list.js';
import GlobalVarAdd from './routes/globalVar/add.js';
/* 库存 */
import Inventory from './routes/inventory';
import Warehouse from './routes/inventory/warehouse';
import SaleRank from './routes/inventory/saleRankList';
import AddHouse from './routes/inventory/addHouse';
import HouseDetail from './routes/inventory/houseDetail';
import QueryInventory from './routes/inventory/inventory';
import Records from './routes/inventory/records';
import NotReaching from './routes/inventory/notReaching';
import GoDownEntry from './routes/inventory/godownEntry';
import AddEntry from './routes/inventory/addEntry';
/* 库存 end */
/* 退货订单 */
import ReturnOrder from './routes/returnOrder';
import ReturnOrderList from './routes/returnOrder/list.js';
import ReturnOrderDetail from './routes/returnOrder/detail.js';
/* 订单 end */
import Zone from './routes/zone';
/* 首页设置 */
import HomeSet from './routes/homeSet';
import HomeSetEdit from './routes/homeSet/edit.js';
/* 首页设置 end */
/* 资讯 */
import Info from './routes/info';
import InfoList from './routes/info/list';
import AddInfo from './routes/info/add';
import InfoDetail from './routes/info/detail';
import InfoComment from './routes/info/comment';
/* 资讯 end */
/* 通知公告 */
import Notice from './routes/notice';
import NoticeList from './routes/notice/list';
import AddNotice from './routes/notice/add';
import NoticeDetail from './routes/notice/detail';
/* 通知公告 end */
/* 广告发布管理 */
import Carousel from './routes/carousel';
import CarouselList from './routes/carousel/list';
import AddCarousel from './routes/carousel/add';
import CarouselDetail from './routes/carousel/detail';
/* 广告发布管理 end */
/* 商品管理 */
import Merchandise from './routes/merchandise';
import MerchandiseList from './routes/merchandise/list';
import AddMerchandise from './routes/merchandise/add';
/* 广告发布管理 end */
/* 渠道赋能 */
import ChannelFunc from './routes/channelFunc';
import ChannelFuncList from './routes/channelFunc/list';
import AddFunc from './routes/channelFunc/add';
import ChannelFuncDetail from './routes/channelFunc/detail';
import ChannelFuncComment from './routes/channelFunc/comment';
/* 资讯阅读 */
import InfoRead from './routes/infoRead';
import InfoReadList from './routes/infoRead/list';


/*供应链融资*/
import Financing from './routes/financing';
import Zsbank from './routes/financing/zsbank';

/* 渠道赋能 end */
import Org from './routes/org';
import People from './routes/people';
import PeopleAdd from './routes/people/add.js';
import PeopleList from './routes/people/list.js';
import PeopleDetail from './routes/people/detail.js';
import Account from './routes/account';
import Job from './routes/job';
/* 消息中心 */
import Message from './routes/message';
import MessageList from './routes/message/list.js';
import MessageDetail from './routes/message/detail.js';
/* 委托书 */
import Entrust from './routes/entrust';
import EntrustEdit from './routes/entrust/edit.js';
/* 开单管控配置 */
import BillingCtrl from './routes/billingCtrl';
import BillingCtrlList from './routes/billingCtrl/list';
import BillingAdd from './routes/billingCtrl/add';
import CustItem from './routes/billingCtrl/list2';
/* 收货确认 */
import Receiving from './routes/receiving';
import ReceivingList from './routes/receiving/list';
/* 退货管理 */
import ReturnGoods from './routes/returnGoods';
import ReturnGoodsList from './routes/returnGoods/list';
import QualityAdd from './routes/returnGoods/quality';
import BusinessAdd from './routes/returnGoods/business';
import ReturnGoodsDetail from './routes/returnGoods/detail';
import DetailReport from './routes/returnGoods/detailReport';
/* 追溯订单 */
import TraceOrder from './routes/traceOrder';
import TraceOrderList from './routes/traceOrder/list';
import TraceOrderAdd from './routes/traceOrder/add';
import TraceOrderDetail from './routes/traceOrder/detail';
/*特殊订单*/
import SpecialOrder from './routes/specialOrder';
import SpecialOrderList from './routes/specialOrder/list';
import SpecialOrderAdd from './routes/specialOrder/add';
import SpecialOrderDetail from './routes/specialOrder/detail';
/*出库单二次配送*/
import TransportSplit from './routes/transportSplit';
import TransportSplitList from './routes/transportSplit/list';
import TransportSplitAdd from "./routes/transportSplit/add";
import TransportSplitPrint from './routes/print/transportSplitPrint.js';
/* 定制订单 */
import CustomOrder from './routes/customOrder';
import CustomOrderList from './routes/customOrder/list';
import CustomOrderAdd from './routes/customOrder/add';
import CustomOrderDetail from './routes/customOrder/detail';
import CompanyLink from './routes/print/companyLink';
/* 预订单 */
import PreOrder from './routes/preOrder';
import PreOrderList from './routes/preOrder/list';
import PreOrderDetail from './routes/preOrder/detail';
/* 评论管理 */
import Comment from './routes/comment';
import CommentList from './routes/comment/list';
/* 财务管理 */
import SalesQuery from './routes/financialMgm/salesQuery';
import SalesQueryList from './routes/financialMgm/salesQueryList';
import ReceivedPayment from './routes/financialMgm/receivedPayment';
import ReceivedPaymentList from './routes/financialMgm/receivedPaymentList';
import ReceivedPaymentAdd from './routes/financialMgm/receivedPaymentAdd';
import ReceivedPaymentEdit from './routes/financialMgm/receivedPaymentEdit';
import ReceivedPaymentDetail from './routes/financialMgm/receivedPaymentDetail';
import Payment from './routes/financialMgm/payment';
import PaymentList from './routes/financialMgm/paymentList';
import PaymentAdd from './routes/financialMgm/paymentAdd';
import PaymentEdit from './routes/financialMgm/paymentEdit';
import PaymentDetail from './routes/financialMgm/paymentDetail';
import Verifying from './routes/financialMgm/verifying';
import VerifyingList from './routes/financialMgm/verifyingList';
import OtherInfo from './routes/financialMgm/otherInfo';
import OtherInfoList from './routes/financialMgm/otherInfoList';
import VerifyingDetail from './routes/financialMgm/verifyingDetail';
import VerifyingDetailList from './routes/financialMgm/verifyingDetailList';
/* 二级客户订单 */
import SecondCusOrder from './routes/secCusOrder';
import SecondCusOrderList from './routes/secCusOrder/list';
import SecondCusOrderAdd from './routes/secCusOrder/add';
import SecondCusOrderDetail from './routes/secCusOrder/detail';
import SecondCusOrderSend from './routes/secCusOrder/send';
/* 客户管理*/
/* 客户管理-客户管理*/
import CustomerManagement from './routes/customerManagement';
import CustomerManagementList from './routes/customerManagement/list.js';
import CustomerManagementDetail from './routes/customerManagement/detail.js';
/* 客户管理-收货单位*/
import PurchaseUnit from './routes/purchaseUnit';
import PurchaseUnitList from './routes/purchaseUnit/list.js';
import PurchaseUnitDetail from './routes/purchaseUnit/detail.js';
/* 客户管理-授信变动情况*/
import CreditChange from './routes/creditChange';
import CreditChangeList from './routes/creditChange/list.js';
/* 客户管理 end */
/* 产品 */
import Product from './routes/product';
import ProductEnList from './routes/product/listEn.js';
import ProductList from './routes/product/list.js';
import ProductDetail from './routes/product/detail.js';
import ProductAdd from './routes/product/add.js';
/* 返利单管理 */
import RebateBill from './routes/rebateBillManage';
import RebateBillList from './routes/rebateBillManage/list.js';

/* 产品 */
import Quotation from './routes/quotation';
import QuotationList from './routes/quotation/list.js';
import QuotationDetail from './routes/quotation/detail.js';
import QuotationAdd from './routes/quotation/add.js';
/* 产品 end */
/* 购物车 */
import ShoppingCar from './routes/shoppingCar';
import ShoppingCarList from './routes/shoppingCar/list';
import ShoppingCarAdd from './routes/shoppingCar/add';
/* 购物车end */
/* 我的收藏 */
import Favorites from './routes/favorites';
import FavoritesList from './routes/favorites/list';
/* 我的收藏end */
/* 订单 */
import Order from './routes/order';
import OrderList from './routes/order/list.js';
import ConventionalDetail from './routes/order/conventionalDetail';
import ProjectDetail from './routes/order/projectDetail';
import PartnersDetail from './routes/order/partnersDetail';
import AddConventional from './routes/order/addConventional';
import AddProject from './routes/order/addProject';
import AddPartners from './routes/order/addPartners';
import Evaluation from './routes/order/evaluate';
import SpecialPriceQuery from './routes/order/specialPriceQuery';
import OrderTrackQuery from './routes/order/orderTrackQuery';
/*开票管理*/
import InvoiceManagement from './routes/invoiceManagement';
import InvoiceList from './routes/invoiceManagement/list.js';
import InvoiceApplyStart from './routes/invoiceManagement/invoiceApplyStart.js';
import InvoiceApply from './routes/invoiceManagement/invoiceApply.js';
import InvoiceStaging from './routes/invoiceManagement/invoiceStaging.js';
import NormalInvoice from './routes/invoiceManagement/normalInvoice.js';
import SpecialInvoice from './routes/invoiceManagement/specialInvoice.js';
import InvoiceDetail from './routes/invoiceManagement/detail.js';
/* 开票管理 end */
/* 库存查询 */
import InventoryQuery from './routes/inventoryQuery';
import InventoryQueryList from './routes/inventoryQuery/list.js';
import ScheduleList from './routes/inventoryQuery/scheduleList.js';

/* 库存查询 end */
/* 事物管理——客户管理(二级) */
import Customer from './routes/customer';
import CustomerList from './routes/customer/list.js';
import CustomerAdd from './routes/customer/add.js';
import CustomerDetail from './routes/customer/detail.js';
/* 事物管理——订单管理(二级) */
import ThingsOrder from './routes/thingsOrder';
import ThingsOrderList from './routes/thingsOrder/list';
import ThingsOrderAddCopy from './routes/thingsOrder/addCopy';
import ThingsOrderAdd from './routes/thingsOrder/add';
import ThingsOrderDetail from './routes/thingsOrder/detail';
import MianJiaPrint from './routes/print/mianjiaPrint.js';
import BuHanMianJiaPrint from './routes/print/buhanmianjiaPrint.js';
import BuHanMianJiaPrintA4 from './routes/print/buhanmianjiaPrintA4.js';
import OrdinaryPrint from './routes/print/ordinaryPrint.js';
import ReceiptPrint from './routes/print/receiptPrint.js';
import SalesList from './routes/thingsOrder/salesList.js';
/* 事物管理——其他产品管理(二级) */
import ProductCustomer from './routes/productCustomer';
import ProductCustomerList from './routes/productCustomer/list';
import ProductCustomerAdd from './routes/productCustomer/add';
/* 事物管理——子库存管理(二级) */
import SubStock from './routes/subStock';
import SubStockList from './routes/subStock/list';
import SubStockAdd from './routes/subStock/add';
/* 事物管理——安全库存设置(二级) */
import SaferStorageSet from './routes/saferStorageSet/list.js';
import Dealer from './routes/dealer/dealer.js';
/*事物管理-下浮设置*/
import Lower from './routes/lower/index.js';
import LowerList from './routes/lower/list.js';
import LowerAdd from './routes/lower/add.js';
/*报表*/
import AccountInformation from './routes/reportForm/accountInformation';
import DiscountedReport from './routes/reportForm/discountedReport';
import DiscountStatements from './routes/reportForm/discountStatements';
import AccountStatement from './routes/reportForm/accountStatement';
import CustomerReceivableInquiry from './routes/reportForm/customerReceivableInquiry';
import CustomerInvoice from './routes/reportForm/customerInvoice';
import CustomerInvoiceDetail from './routes/reportForm/customerInvoiceDetail';
import CustomerNoInvoice from './routes/reportForm/customerNoInvoice';
import CustomerReturnQuery from './routes/reportForm/customerReturnQuery';
import DiscountPoolInquiries from './routes/reportForm/discountPoolInquiries';
import DeffDeliveryOfferQuery from './routes/reportForm/deffDeliveryOfferQuery';
import CustomerTaxReturnQuery from './routes/reportForm/customerTaxReturnQuery';
import FinanceChart from './routes/reportForm/FinanceChart';
import PurchaseChart from './routes/reportForm/PurchaseChart';
import SettleDetailQuery from './routes/reportForm/settleDetailQuery';
/*分析报表*/
import Report from "./routes/report";
import BiReport from "./routes/report/biReport";
/*库存管理*/
import StockControl from './routes/stockControl/index.js';
import StockControlList from './routes/stockControl/list.js';
import WarehouseInventoryQuery from './routes/stockControl/warehouseInventoryQuery.js';
import SublibraryTransfer from './routes/stockControl/sublibraryTransfer.js';
import sundryInStorage from './routes/stockControl/sundryInStorage.js';
import sundryOutStorage from './routes/stockControl/sundryOutStorage.js';
import StoreOutInList from './routes/stockControl/storeOutInList.js';
/* 个人信息 */
import ProfileMgr from './routes/profile';
import ProfileInfo from './routes/profile/info';
import ForcedChangePassword from './routes/profile/forcedChangePassword';
/* 问卷调查 */
import Survey from './routes/survey';
import SurveyList from './routes/survey/list';
import SurveyAdd from './routes/survey/add';
import SurveyResult from './routes/survey/result';
import SurveyDetail from './routes/survey/detail';
/*开票物料维护*/
import InvoiceItemMap from "./routes/invoiceItemMap";
import InvoiceItemMapList from "./routes/invoiceItemMap/list";
import DeliveryInvoicelist from "./routes/invoiceItemMap/deliveryInvoicelist";
/*欠货查询*/
import Owning from './routes/searchOwning';
import SearchOwning from './routes/searchOwning/list';
/*退货*/
import ReturnGoodsPrint from './routes/print/returnGoodsPrint.js';
import DeliveryConfirmPrint from './routes/print/deliveryConfirmPrint.js';
import BuyReturnPrint from './routes/print/buyReturnPrint.js';
import ReturnOutstorckPrint from './routes/print/returnOutstorckPrint.js';
/*发货查询*/
import Delivery from './routes/searchDelivery';
import SearchDelivery from './routes/searchDelivery/list';
/*商品选型库*/
import MallCommon from './mall/mallDetail/index';
import MallMerchandiseDetail from './mall/mallDetail/merchandiseDetail';
import MallSelectProduct from './mall/mallDetail/selectProduct';
import SearchMall from './mall/mallDetail/searchMall';
import MCHRoot from './mall/mallHome/root';
import MallHome from './mall/mallHome';
import SelectHome from './mall/mallHome/selectHome.js';
import MallCart from './mall/mallCart';
// import MallOrderIndex from './mall/mallOrder';
// import MallOrderDetail from './mall/mallOrder/detail';
// import MallOrderEvaluate from './mall/mallOrder/evaluate';
import MallPay from './mall/mallPay';
import SettleAccounts from './mall/mallPay/settleAccounts';
import SubmitOrder from './mall/mallPay/submitOrder';
import GoPay from './mall/mallPay/goPay';
import UserCenter from './mall/userCenter';
// import MallOrder from './mall/userCenter/order';
// import Exchange from './mall/userCenter/exchange';
// import MallMessage from './mall/userCenter/message';
// import MsgDetail from './mall/userCenter/msgDetail';
import Collection from './mall/userCenter/collection';
import UserInfo from './mall/userCenter/userInfo';
import Address from './mall/userCenter/address';
import ViewBox from './routes/order';
// import Ticket from './mall/userCenter/ticket';
// import MallReturnOrder from './mall/mallReturnOrder';
// import ApplyReturnOrder from './mall/mallReturnOrder/apply';
// import CheckReturnOrder from './mall/mallReturnOrder/check';

/*代管订单发货请求*/
import ShipRequest from "./routes/shipRequest/index";
import ShipRequestQuery from './routes/shipRequest/shipRequestQuery';
import ShipRequestHistory from './routes/shipRequest/shipRequestHistory';
import ShipRequestPrint from "./routes/shipRequest/shipRequestPrint";
import ShipRequestPrintBatch from "./routes/shipRequest/shipRequestPrintBatch";
import ShipRequestPrintBatchSummary from "./routes/shipRequest/shipRequestPrintBatchSummary";
import WaitReceiptQuery from "./routes/shipRequest/waitReceiptQuery";
import OnhandQuery from "./routes/shipRequest/onhandQuery";
import TransactionQuery from "./routes/shipRequest/transactionQuery";
import EscrowDetailQuery from "./routes/shipRequest/escrowDetailQuery";

/*分批签收*/
import BatchAcceptList from "./routes/transportSplit/batchAcceptList";


/*商品选型库 end*/
class DMS extends React.Component {
    render() {
        return <Router history={hashHistory}>
            <Route name="登录" path="/" component={Login}/>
            <Route name="首页" path="/" component={App}>
                <Route name="首页" path="home" component={Home}/>
                <Route name="消息中心" path="message" component={Message}>
                    <IndexRoute component={MessageList}/>
                    <Route name="消息详情" path=":entityId/:entityType" component={MessageDetail}/>
                </Route>
                <Route name="对账信息" path="accountInformation" component={AccountInformation}/>
                <Route name="采购报表" path="purchaseChart" component={PurchaseChart}/>
                <Route name="财务报表" path="financeChart" component={FinanceChart}/>
                <Route name="发运含折让报表" path="discountedReport" component={DiscountedReport}/>
                <Route name="开单含折让报表" path="discountStatements" component={DiscountStatements}/>
                <Route name="对账单明细报表" path="accountStatement" component={AccountStatement}/>
                <Route name="退货明细报表" path="detailReport" component={DetailReport}/>
                <Route name="客户开票情况查询" path="customerInvoice" component={CustomerInvoice}/>
                <Route name="客户开票情况明细查询" path="customerInvoiceDetail" component={CustomerInvoiceDetail}/>
                <Route name="客户未开票明细表" path="customerNoInvoice" component={CustomerNoInvoice}/>
                <Route name="客户应收查询" path="customerReceivableInquiry" component={CustomerReceivableInquiry}/>
                <Route name="客户回款查询" path="customerReturnQuery" component={CustomerReturnQuery}/>
                <Route name="折扣池明细查询" path="discountPoolInquiries" component={DiscountPoolInquiries}/>
                <Route name="特殊发运申请查询" path="deffDeliveryOfferQuery" component={DeffDeliveryOfferQuery}/>
                <Route name="结算明细报表" path="settleDetailQuery" component={SettleDetailQuery}/>
                <Route name="发票池退货关联表" path="customerTaxReturnQuery" component={CustomerTaxReturnQuery}/>
                <Route name="客户管理" path="customerManagement" component={CustomerManagement}>
                    <IndexRoute component={CustomerManagementList}/>
                    <Route name="客户详情" path=":customerManagementId" component={CustomerManagementDetail}/>
                </Route>
                <Route name="授信变动情况" path="creditChange" component={CreditChange}>
                    <IndexRoute component={CreditChangeList}/>
                </Route>
                <Route name="购货单位" path="purchaseUnit" component={PurchaseUnit}>
                    <IndexRoute component={PurchaseUnitList}/>
                    <Route name="购货单位详情" path=":purchaseUnitId" component={PurchaseUnitDetail}/>
                </Route>
                <Route name="产品管理" path="product" component={Product}>
                    <IndexRoute component={ProductList}/>
                    <Route name="新增产品" path="add/:productId" component={ProductAdd}/>
                    <Route name="产品详情" path=":productId" component={ProductDetail}/>
                    <Route name="海外价格查询" component={ProductEnList}/>
                </Route>
                <Route name="海外价格查询" path="productEn" component={Product}>
                    <IndexRoute component={ProductEnList}/>
                </Route>
                <Route name="返利结算单管理" path="rebateBillManage" component={RebateBill}>
                    <IndexRoute component={RebateBillList}/>
                </Route>
                <Route name="报价单" path="quotation" component={Quotation}>
                    <IndexRoute component={QuotationList}/>
                    <Route name="新增报价单" path="add/:id" component={QuotationAdd}/>
                    <Route name="报价单详情" path=":id" component={QuotationDetail}/>
                </Route>
                <Route name="购物车" path="shoppingCar" component={ShoppingCar}>
                    <IndexRoute component={ShoppingCarList}/>
                    <Route name="生成订单" path="add/:id" component={ShoppingCarAdd}/>
                    <Route name="生成订单" path="add1/:id&:cusId&:customer&:userId" component={ShoppingCarAdd}/>
                </Route>
                <Route name="我的收藏" path="favorites" component={Favorites}>
                    <IndexRoute component={FavoritesList}/>
                </Route>
                <Route name="订单管理" path="order" component={Order}>
                    <IndexRoute component={OrderList}/>
                    <Route name="常规订单详情" path=":orderId/conventionalDetail/:orderNumber"
                           component={ConventionalDetail}/>
                    <Route name="常规订单详情" path=":orderId/conventionalDetail1/:orderNumber/:orderStatus"
                           component={ConventionalDetail}/>
                    <Route name="项目订单详情" path=":orderId/projectDetail/:orderNumber" component={ProjectDetail}/>
                    <Route name="项目订单详情" path=":orderId/projectDetail1/:orderNumber/:orderStatus"
                           component={ProjectDetail}/>
                    <Route name="合作伙伴订单详情" path=":orderId/partnersDetail/:orderNumber"
                           component={PartnersDetail}/>
                    <Route name="合作伙伴订单详情" path=":orderId/partnersDetail1/:orderNumber/:orderStatus"
                           component={PartnersDetail}/>
                    <Route name="新增常规订单" path="addConventional" component={AddConventional}/>
                    <Route name="新增常规订单" path="addConventional/:id" component={AddConventional}/>
                    <Route name="新增常规订单" path="addConventional1/:id&:orderId" component={AddConventional}/>
                    <Route name="新增常规订单" path="addConventional2/:id&:orderId&:type" component={AddConventional}/>
                    <Route name="新增项目订单" path="addProject" component={AddProject}/>
                    <Route name="新增项目订单" path="addProject/:id" component={AddProject}/>
                    <Route name="新增项目订单" path="addProject1/:id&:orderId" component={AddProject}/>
                    <Route name="新增项目订单" path="addProject2/:id&:orderId&:type" component={AddProject}/>
                    <Route name="新增合作伙伴订单" path="addPartners" component={AddPartners}/>
                    <Route name="新增合作伙伴订单" path="addPartners/:id" component={AddPartners}/>
                    <Route name="新增合作伙伴订单" path="addPartners1/:id&:orderId" component={AddPartners}/>
                    <Route name="新增合作伙伴订单" path="addPartners2/:id&:orderId&:type" component={AddPartners}/>
                    <Route name="订单评价" path="evaluate/:orderId/:orderProductId" component={Evaluation}/>
                </Route>
                <Route name="开票管理" path="invoiceManagement" component={InvoiceManagement}>
                    <IndexRoute component={InvoiceList}/>
                    <Route name="开票申请起始页" path="invoiceApplyStart" component={InvoiceApplyStart}/>
                    <Route name="开票申请" path="invoiceApply" component={InvoiceApply}/>
                    <Route name="开票暂存单" path="invoiceStaging" component={InvoiceStaging}/>
                    <Route name="正常开票" path="normalInvoice" component={NormalInvoice}/>
                    {/* <Route name="正常开票" path="normalInvoice/:params" component={NormalInvoice}/>*/}
                    <Route name="特殊开票" path="specialInvoice" component={SpecialInvoice}/>
                    <Route name="开票详情" path=":invoiceManagementId/:tag" component={InvoiceDetail}/>
                </Route>
                <Route name="开票物料维护" path="invoiceItemMap" component={InvoiceItemMap}>
                    <IndexRoute component={InvoiceItemMapList}/>
                </Route>
                <Route name="发票台账" path="deliveryInvoicelist" component={DeliveryInvoicelist}/>
                <Route name="库存查询" path="inventoryQuery" component={InventoryQuery}>
                    <IndexRoute component={InventoryQueryList}/>
                </Route>
                <Route name="交期查询" path="scheduleList" component={ScheduleList}/>
                <Route name="客户管理(二级)" path="customer" component={Customer}>
                    <IndexRoute component={CustomerList}/>
                    <Route name="新增客户" path="add/:customerId" component={CustomerAdd}/>
                    <Route name="客户详情" path=":customerId" component={CustomerDetail}/>
                </Route>
                <Route name="订单管理(二级)" path="thingsOrder" component={ThingsOrder}>
                    <IndexRoute component={ThingsOrderList}/>
                    <Route name="订单管理新增" path="add" component={ThingsOrderAdd}/>
                    <Route name="订单管理编辑" path="edit/:id" component={ThingsOrderAdd}/>
                    <Route name="订单管理详情" path=":id" component={ThingsOrderDetail}/>
                    <Route name="订单复制" path="addCopy/:id" component={ThingsOrderAddCopy}/>
                </Route>
                <Route name="销售明细报表" path="salesList" component={SalesList}></Route>
                <Route name="销售排行" path="saleRank" component={SaleRank}/>
                {/*<Route name="面价打印" path="mianjiaprint" component={MianJiaPrint}/>*/}
                <Route name="其他产品管理(二级)" path="productCustomer" component={ProductCustomer}>
                    <IndexRoute component={ProductCustomerList}/>
                    <Route name="新增其他产品(二级)" path="add(/:productId)" component={ProductCustomerAdd}/>
                </Route>
                <Route name="子库存管理(二级)" path="subStock" component={SubStock}>
                    <IndexRoute component={SubStockList}/>
                    <Route name="新增子库存管理(二级)" path="add" component={SubStockAdd}/>
                    <Route name="新增子库存管理(二级)" path="edit/:productId" component={SubStockAdd}/>
                </Route>
                <Route name="库存管理" path="stockControl" component={StockControl}>
                    <IndexRoute component={StockControlList}/>
                    <Route name="子库转移" path="sublibraryTransfer" component={SublibraryTransfer}/>
                    <Route name="杂项入库" path="sundryInStorage" component={sundryInStorage}/>
                    <Route name="杂项出库" path="sundryOutStorage" component={sundryOutStorage}/>
                </Route>
                <Route name="收发存报表" path="storeOutInList" component={StoreOutInList}></Route>
                <Route name="下浮设置" path="lower" component={Lower}>
                    <IndexRoute component={LowerList}/>
                    <Route name="新增下浮" path="lowerAdd/:linkmanId" component={LowerAdd}/>
                </Route>
                <Route name="出入库记录查询" path="warehouseInventoryQuery" component={WarehouseInventoryQuery}/>
                <Route name="安全库存设置" path="saferStorageSet" component={SaferStorageSet}/>
                <Route name="经销商信息维护" path="dealer" component={Dealer}/>
                <Route name="开单管控配置" path="billingCtrl" component={BillingCtrl}>
                    <IndexRoute component={BillingCtrlList}/>
                    <Route name="开单管控配置新建" path="add/:addId" component={BillingAdd}/>
                </Route>
                <Route name="客户专属物料" path="custItem" component={CustItem}/>
                <Route name="个人信息" path="profile" component={ProfileMgr}>
                    <IndexRoute component={ProfileInfo}/>
                </Route>
                <Route name="强制修改密码" path="forcedChangePassword" component={ForcedChangePassword}/>
                <Route name="收货确认" path="receiving" component={Receiving}>
                    <IndexRoute component={ReceivingList}/>
                </Route>
                <Route name="退货管理" path="returnGoods" component={ReturnGoods}>
                    <IndexRoute component={ReturnGoodsList}/>
                    <Route name="质量退货" path="quality(/:id)" component={QualityAdd}/>
                    <Route name="商务退货" path="business(/:id)" component={BusinessAdd}/>
                    <Route name="退货详情" path=":orderId&:type" component={ReturnGoodsDetail}/>
                </Route>

                <Route name="分析报表" path="report" component={Report}>
                    <IndexRoute component={BiReport}/>
                </Route>

                <Route name="欠货管理" path="owning" component={Owning}>
                    <IndexRoute component={SearchOwning}/>
                </Route>
                <Route name="发货管理" path="delivery" component={Delivery}>
                    <IndexRoute component={SearchDelivery}/>
                </Route>
                <Route name="特价查询" path="specialPriceQuery" component={SpecialPriceQuery}/>
                <Route name="未发跟踪" path="orderTrackQuery" component={OrderTrackQuery}/>
                <Route name="追溯订单" path="traceOrder" component={TraceOrder}>
                    <IndexRoute component={TraceOrderList}/>
                    <Route name="追溯订单创建" path="add" component={TraceOrderAdd}/>
                    <Route name="追溯订单编辑" path="edit/:id" component={TraceOrderAdd}/>
                    <Route name="追溯订单详情" path=":orderId" component={TraceOrderDetail}/>
                </Route>
                <Route name="特殊订单" path="specialOrder" component={SpecialOrder}>
                    <IndexRoute component={SpecialOrderList}/>
                    <Route name="特殊订单创建" path="add" component={SpecialOrderAdd}/>
                    <Route name="特殊订单编辑" path="edit/:id" component={SpecialOrderAdd}/>
                    <Route name="特殊订单详情" path=":id" component={SpecialOrderDetail}/>
                </Route>
                <Route name="二次配送" path="transportSplit" component={TransportSplit}>
                    <IndexRoute component={TransportSplitList}/>
                    <Route name="二次配送创建" path="add" component={TransportSplitAdd}/>
                </Route>
                <Route name="分批签收" path="batchAccept" component={BatchAcceptList}> </Route>
                <Route name="托管订单发运" path="ShipRequestQuery" component={ShipRequestQuery}> </Route>
                <Route name="托管订单历史" path="ShipRequestHistory" component={ShipRequestHistory}> </Route>
                <Route name="托管订单接收" path="WaitReceiptQuery" component={WaitReceiptQuery}> </Route>
                <Route name="托管订单库存查询" path="OnhandQuery" component={OnhandQuery}> </Route>
                <Route name="托管订单出入库查询" path="TransactionQuery" component={TransactionQuery}> </Route>
                <Route name="托管订单在途查询" path="EscrowDetailQuery" component={EscrowDetailQuery}> </Route>
                <Route name="定制订单" path="customOrder" component={CustomOrder}>
                    <IndexRoute component={CustomOrderList}/>
                    <Route name="定制订单创建" path="add" component={CustomOrderAdd}/>
                    <Route name="定制订单详情" path=":id" component={CustomOrderDetail}/>
                </Route>
                <Route name="预订单" path="preOrder" component={PreOrder}>
                    <IndexRoute component={PreOrderList}/>
                    <Route name="预订单详情" path=":headerId&:status" component={PreOrderDetail}/>
                </Route>
                <Route name="评论管理" path="comment" component={Comment}>
                    <IndexRoute component={CommentList}/>
                </Route>
                <Route name="销售查询" path="salesQuery" component={SalesQuery}>
                    <IndexRoute component={SalesQueryList}/>
                </Route>
                <Route name="客户回款核销" path="receivedPayment" component={ReceivedPayment}>
                    <IndexRoute component={ReceivedPaymentList}/>
                    <Route name="客户回款核销创建" path="add/:id" component={ReceivedPaymentAdd}/>
                    <Route name="客户回款核销编辑" path="edit/:id" component={ReceivedPaymentEdit}/>
                    <Route name="客户回款核销详情" path="detail/:id" component={ReceivedPaymentDetail}/>
                </Route>
                <Route name="应付记录" path="payment" component={Payment}>
                    <IndexRoute component={PaymentList}/>
                    <Route name="新增应付" path="add/:id" component={PaymentAdd}/>
                    <Route name="应付核销" path="edit/:id" component={PaymentEdit}/>
                    <Route name="应付详情" path="detail/:id" component={PaymentDetail}/>
                </Route>
                <Route name="财务对账" path="verifying" component={Verifying}>
                    <IndexRoute component={VerifyingList}/>
                </Route>
                <Route name="其他信息录入" path="otherInfo" component={OtherInfo}>
                    <IndexRoute component={OtherInfoList}/>
                </Route>
                <Route name="核销明细报表" path="verifyingDetail" component={VerifyingDetail}>
                    <IndexRoute component={VerifyingDetailList}/>
                </Route>
                <Route name="二级客户订单" path="secCusOrder" component={SecondCusOrder}>
                    <IndexRoute component={SecondCusOrderList}/>
                    <Route name="新增二级客户订单" path="add/:id" component={SecondCusOrderAdd}/>
                    <Route name="二级客户订单详情" path="detail/:id" component={SecondCusOrderDetail}/>
                    <Route name="二级客户订单发货" path="send" component={SecondCusOrderSend}/>
                </Route>
                <Route name="问卷调查" path="survey" component={Survey}>
                    <IndexRoute component={SurveyList}/>
                    <Route name="新建问卷调查" path="add" component={SurveyAdd}/>
                    <Route name="问卷调查详情" path=":surveyId" component={SurveyDetail}/>
                    <Route name="问卷结果" path=":surveyId/result" component={SurveyResult}/>
                </Route>
                <Route name="供应链融资" path="financing" component={Financing}>
                    <IndexRoute component={Zsbank}/>
                    <Route name="浙商银行" path="zsbank" component={Zsbank}/>
                </Route>
                <Route name="首页设置" path="homeSet" component={HomeSet}>
                    <IndexRoute component={HomeSetEdit}/>
                </Route>
                <Route name="委托书模板" path="entrust" component={Entrust}>
                    <IndexRoute component={EntrustEdit}/>
                </Route>
                <Route name="退货订单" path="returnOrder" component={ReturnOrder}>
                    <IndexRoute component={ReturnOrderList}/>
                    <Route name="退货订单详情" path=":orderId" component={ReturnOrderDetail}/>
                </Route>
                <Route name="促销管理" path="Promotion" component={Promotion}>
                    <IndexRoute component={PromotionList}/>
                    <Route name="新增促销" path="add/:promotionId" component={PromotionAdd}/>
                    <Route name="促销详情" path=":promotionId" component={PromotionDetail}/>
                </Route>
                <Route name="卡券管理" path="card" component={Card}>
                    <IndexRoute component={CardList}/>
                    <Route name="新增卡券" path="add/:cardId" component={CardAdd}/>
                </Route>
                <Route name="渠道管理" path="channel" component={Channel}>
                    <IndexRoute component={ChannelList}/>
                    <Route name="新增渠道" path="add/:channelId" component={ChannelAdd}/>
                    <Route name="渠道详情" path=":channelId" component={ChannelDetail}/>
                </Route>
                <Route name="全部附件" path="file" component={FileList}/>
                <Route name="全部备注" path="remark" component={RemarkList}/>
                <Route name="门店管理" path="store" component={Store}>
                    <IndexRoute component={StoreList}/>
                    <Route name="新增门店" path="add/:storeId" component={StoreAdd}/>
                    <Route name="门店详情" path=":storeId" component={StoreDetail}/>
                </Route>
                <Route name="全部员工" path="staff/:storeId" component={Staff}>
                    <IndexRoute component={StaffList}/>
                    <Route name="新增员工" path="add/:staffId" component={StaffAdd}/>
                    <Route name="员工详情" path=":staffId" component={StaffDetail}/>
                </Route>
                <Route name="全部联系人" path="linkman/:channelId" component={Linkman}>
                    <IndexRoute component={LinkmanList}/>
                    <Route name="新增联系人" path="add/:linkmanId" component={LinkmanAdd}/>
                    <Route name="联系人详情" path=":linkmanId" component={LinkmanDetail}/>
                </Route>

                <Route name="仓库列表" path="warehouse" component={Inventory}>
                    <IndexRoute component={Warehouse}/>
                    <Route name="新增仓库" path="add/:id" component={AddHouse}/>
                    <Route name="仓库详情" path=":id" component={HouseDetail}/>
                </Route>
                <Route name="库存查询" path="inventory" component={QueryInventory}/>
                <Route name="在途库存查询" path="notReaching" component={NotReaching}/>
                <Route name="出入库记录" path="inventoryRecords" component={Records}/>
                <Route name="入库单" path="goDownEntry" component={Inventory}>
                    <IndexRoute component={GoDownEntry}/>
                    <Route name="新建入库单" path="add/:id" component={AddEntry}/>
                </Route>

                <Route name="资讯管理" path="info" component={Info}>
                    <IndexRoute component={InfoList}/>
                    <Route name="新建发布" path="add/:id" component={AddInfo}/>
                    <Route name="资讯详情" path=":id" component={InfoDetail}/>
                    <Route name="评论列表" path=":id/comment/list" component={InfoComment}/>
                </Route>
                <Route name="通知公告" path="notice" component={Notice}>
                    <IndexRoute component={NoticeList}/>
                    <Route name="新建发布" path="add/:id" component={AddNotice}/>
                    <Route name="资讯详情" path=":id" component={NoticeDetail}/>
                </Route>
                <Route name="广告发布管理" path="carousel" component={Carousel}>
                    <IndexRoute component={CarouselList}/>
                    <Route name="新建广告发布" path="add/:id" component={AddCarousel}/>
                    <Route name="广告发布详情" path=":id" component={CarouselDetail}/>
                </Route>
                <Route name="商品管理" path="merchandise" component={Merchandise}>
                    <IndexRoute component={MerchandiseList}/>
                    <Route name="新建商品" path="add/:id" component={AddMerchandise}/>
                </Route>
                <Route name="渠道赋能" path="channelFunc" component={ChannelFunc}>
                    <IndexRoute component={ChannelFuncList}/>
                    <Route name="新建发布" path="add/:id" component={AddFunc}/>
                    <Route name="资讯详情" path=":id" component={ChannelFuncDetail}/>
                    <Route name="评论列表" path=":id/comment/list" component={ChannelFuncComment}/>
                </Route>
                <Route name="资讯阅读" path="infoRead" component={InfoRead}>
                    <IndexRoute component={InfoReadList}/>
                </Route>
                <Route name="组织架构" path="org" component={Org}/>
                <Route name="人员管理" path="people" component={People}>
                    <IndexRoute component={PeopleList}/>
                    <Route name="人员新建" path="add/:addId" component={PeopleAdd}/>
                    <Route name="人员详情" path="detail/:detailId" component={PeopleDetail}/>
                </Route>
                <Route name="账号管理" path="account" component={Account}/>
                <Route name="岗位管理" path="job" component={Job}/>
                <Route name="地区管理" path="region" component={Region}>
                    <IndexRoute component={RegionList}/>
                    <Route name="新建地区" path="/region/regionadd" component={Regionadd}/>
                </Route>
                <Route name="角色管理" path="role" component={Role}>
                    <IndexRoute component={RoleList}/>
                    <Route name="新建角色" path="/role/roleadd/:roleId" component={Roleadd}/>
                </Route>
                <Route name="区域管理" path="zone" component={Zone}/>
                <Route name="产品分类" path="category" component={Category}>
                    <IndexRoute component={CategoryList}/>
                    <Route name="新建分类" path="/category/categoryadd" component={Categoryadd}/>
                </Route>
                <Route name="产品规格" path="productSpec" component={ProductSpec}>
                    <IndexRoute component={ProductSpecList}/>
                    <Route name="新建规格" path="add/:id" component={ProductSpecadd}/>
                </Route>
                <Route name="产品品牌" path="productBrand" component={ProductBrand}>
                    <IndexRoute component={ProBrandList}/>
                    <Route name="新建品牌" path="add" component={ProBrandAdd}/>
                </Route>
                <Route name="数据字典" path="dictionary" component={Dictionary}>
                    <IndexRoute component={DictionaryList}/>
                    <Route name="新建数据项" path="add/:addId" component={DictionaryAdd}/>
                    <Route name="数据项查看" path="detail/:detailId" component={DictionaryDetail}/>
                    <Route name="新建数据项值" path="additem/:additemId" component={DictionaryAdditem}/>
                </Route>
                <Route name="全局变量" path="globalvar" component={GlobalVar}>
                    <IndexRoute component={GlobalVarList}/>
                    <Route name="新建变量" path="add" component={GlobalVarAdd}/>
                </Route>

                {/*商品选型库 start*/}
                <Route name="商品选型库首页" path="mallHome" component={MallHome}/>
                <Route name="公共头部" path="mallCommon" component={MallCommon}>
                    <Route name="商品详情" path="productDetail/:id/:productId"
                           component={MallMerchandiseDetail}></Route>
                    <Route name="商品详情选型" path="productDetail/:id/:productId/select"
                           component={MallSelectProduct}></Route>
                    <Route name="个人中心" path="userCenter" component={UserCenter}>
                        {/*<Route name="我的订单" path="order" component={MallOrder} />*/}
                        {/*<Route name="退换货" path="exchange" component={Exchange} />*/}
                        {/*<Route name="我的消息" path="message" component={MallMessage} />*/}
                        {/*<Route name="消息详情" path="message/:entityId/:entityType" component={MsgDetail} />*/}
                        <Route name="我的收藏" path="collection" component={Collection}/>
                        <Route name="个人信息" path="userInfo" component={UserInfo}/>
                        <Route name="收货地址" path="address" component={Address}/>
                        {/*<Route name="增票资质" path="ticket" component={Ticket} />*/}
                    </Route>
                    {/*<Route name="mallReturnOrder" path="mallReturnOrder" component={MallReturnOrder}>
            <Route name="申请退换货" path="apply/:orderId/:orderProductId" component={ApplyReturnOrder} />
            <Route name="退换货记录" path=":id/:orderType" component={CheckReturnOrder} />
          </Route>*/}
                    {/*订单页头部与详情页相同，故将路由放置此处*/}
                    {/*<Route name="提交订单" path="mallOrder" component={MallOrderIndex}>
           <Route name="订单详情" path=":id" component={MallOrderDetail} />
           // flag: 0表示新建评价；1表示查看评价
           <Route name="订单评价" path=":id/evaluate/:flag" component={MallOrderEvaluate} />
           </Route>*/}
                </Route>
                <Route name="购物车" path="mallCart" component={MallCart}/>
                <Route name="搜索后商城产品列表显示" path="mallSearch" component={SearchMall}/>
                <Route name="支付" path="mallPay" component={MallPay}>
                    <IndexRoute component={SettleAccounts}/>
                    <Route name="结算页" path="settleAccounts" component={SettleAccounts}/>
                    <Route name="提交订单" path="submitOrder" component={SubmitOrder}/>
                    <Route name="收银台" path="goPay/:id" component={GoPay}/>
                </Route>
                {/*商品选型库 end*/}
            </Route>
            <Route name="面价打印" path="mianjiaprint/:type" component={MianJiaPrint}/>
            <Route name="不含面价打印" path="buhanmianjiaPrint/:type" component={BuHanMianJiaPrint}/>
            <Route name="不含面价打印A4" path="buhanmianjiaPrintA4/:type" component={BuHanMianJiaPrintA4}/>
            <Route name="打印" path="ordinaryPrint/:type" component={OrdinaryPrint}/>
            <Route name="收据打印" path="receiptPrint/:type" component={ReceiptPrint}/>
            <Route name="退货打印" path="returnGoodsPrint" component={ReturnGoodsPrint}/>
            <Route name="收货确认打印" path="deliveryConfirmPrint" component={DeliveryConfirmPrint}/>
            <Route name="回购协议" path="buyReturnPrint" component={BuyReturnPrint}/>
            <Route name="退货单" path="returnOutstorckPrint" component={ReturnOutstorckPrint}/>
            <Route name="生产公司联系方式" path="companyLink" component={CompanyLink}/>
            <Route name="二次配送单据打印" path="transportSplitPrint" component={TransportSplitPrint}/>
            <Route name="配送单据打印" path="shipRequestPrint" component={ShipRequestPrint}/>
            <Route name="配送单据合并打印" path="shipRequestPrintBatch" component={ShipRequestPrintBatch}/>
            <Route name="配送单据汇总打印" path="shipRequestPrintBatchSummary" component={ShipRequestPrintBatchSummary}/>

            <Route name="商品选型库" path="/mallSelect" component={MCHRoot}>
                <IndexRoute component={SelectHome}/>
                <Route name="商品详情" path="productDetail/:id/:productId" component={MallMerchandiseDetail}></Route>
                <Route name="商品详情选型" path="productDetail/:id/:productId/select"
                       component={MallSelectProduct}></Route>
            </Route>

        </Router>;
    }
}

export default DMS;



// WEBPACK FOOTER //
// ./src/route.js